<template>
  <div>

    <v-sheet class="mx-sm-8 pa-4 mb-6 rounded-lg">

      <h2>
        <v-icon>mdi-cloud</v-icon>
        Cloud opgeslagen registraties
        <v-btn outlined color="secondary" small @click="reloadSavedRegistrations">
        <v-icon>mdi-refresh</v-icon>
        Vernieuwen
      </v-btn></h2>

      <v-data-table
          v-if="savedRegistrations.length"
          :headers="headers"
          :items="savedRegistrations"
          class="rounded-lg"
          mobile-breakpoint="0"
          :page.sync="page"
          :loading="loading"
          hide-default-footer
          @click:row="rowClick"
      >
        <template #item.form_name="{ item }">

          <v-tooltip top v-if="_has(item, 'registration_process.errors') && !_isEmpty(item.registration_process.errors)" z-index="50">
            <template #activator="{ on, attrs }">
              <v-icon color="error" class="mr-2" v-bind="attrs" v-on="on">mdi-alert</v-icon>
            </template>
            <span>Er zijn fouten opgetreden bij het verwerken van deze registratie</span>
          </v-tooltip>

          <v-tooltip top v-if="_get(item, 'registration_process.job_status.saved') === false || _get(item, 'registration_process.job_status.sent') === false" z-index="50">
            <template #activator="{ on, attrs }">
              <v-icon color="primary" class="mr-2" v-bind="attrs" v-on="on">mdi-progress-clock</v-icon>
            </template>
            <span>Deze registratie wordt momenteel verwerkt</span>
          </v-tooltip>

          {{ item.form_name }}

        </template>
        <template #item.form_summary="{ item }">
          <div
              class="form-summary"
              v-if="item.form_summary"
              v-html="replaceTokens(item.form_summary, getTokensFromSchema(item.schema), item.values, true, item.schema)"
          ></div>
        </template>
        <template #item.registration_updated_at="{ item }">
          {{ item.registration_updated_at|formatDate }}
        </template>
        <template #item.actions="{ item }">
          <v-btn @click.stop="deleteSavedRegistration(item)" outlined small color="error">Verwijder</v-btn>
        </template>
      </v-data-table>

      <div class="text-center pt-2">
        <v-pagination
            :disabled="loading"
            v-model="page"
            :length="pageCount"
            :total-visible="9"
        ></v-pagination>
      </div>

      <v-container fluid class="pa-md-8 pt-md-2" v-if="!loading && savedRegistrations.length === 0">
        <v-row>
          <v-col>
            U heeft geen opgeslagen registraties.
          </v-col>
        </v-row>
      </v-container>

    </v-sheet>

    <v-dialog v-model="registrationModal" max-width="700" scrollable>
      <v-card>
        <v-card-title>
          Bekijk registratie
          <v-btn icon x-small outlined color="secondary" title="Toon registratie ID" class="ml-2" @click="showRegistrationId = !showRegistrationId">
            <v-icon small>mdi-help</v-icon>
          </v-btn>
          <span class="text-caption ml-3" v-if="registration && showRegistrationId">Is er een probleem met de registratie? Neem dan contact op met de e-formapp support.<br> Registratie ID: {{ registration._id }}</span>
        </v-card-title>
        <v-card-text v-if="registration">

          <v-alert
            v-if="_get(registration, 'registration_process.errors') && !_isEmpty(registration.registration_process.errors)"
            type="error"
            dense
            outlined
            class="mb-4"
          >
            <div v-for="(error, idx) in registration.registration_process.errors" :key="idx">
              <strong>{{ error.date | formatDate }}</strong><br>
              <span>{{ error.message }}</span>
            </div>
          </v-alert>

          <v-alert
              v-if="_get(registration, 'registration_process.concept') === false"
              type="warning"
              dense
              outlined
              class="mb-4"
          >
              U kunt deze registratie niet meer bewerken omdat hij al verstuurd wordt.
          </v-alert>

          <registration-view :registration="registration" :form="registration"></registration-view>
        </v-card-text>
        <v-card-actions>
          <v-btn depressed color="primary" @click="closeRegistrationModal">Sluit</v-btn>
            <v-btn v-if="_get(registration, 'registration_process.concept') === true || !_has(registration, 'registration_process.concept')" outlined color="secondary" @click.stop="editRegistration(registration)">Verder gaan met invullen <v-icon small class="ml-1">mdi-arrow</v-icon></v-btn>
<!--            <v-btn v-if="_get(registration, 'registration_process.concept') === false" outlined color="secondary" @click.stop="fillFormAgain(registration)">Nieuwe registratie met deze waardes <v-icon small class="ml-1">mdi-arrow</v-icon></v-btn>-->
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import eformHelpers from "@/mixins/eformHelpers";
import axios from "axios";
import RegistrationView from "@/components/RegistrationView.vue";
import _ from "lodash";

export default {
  name: "SavedRegistrationList",
  components: {
    RegistrationView,
  },
  mixins: [
    eformHelpers
  ],
  data () {
    return {
      savedRegistrations: [],
      loading: false,
      page: 1,
      pageCount: 0,
      registrationModal: false,
      registration: null,
      showRegistrationId: false,
      headers: [
        {
          text: 'Formulier naam',
          sortable: false,
          align: 'start',
          value: 'form_name',
        },
        {
          text: 'Samenvatting',
          sortable: false,
          align: 'start',
          value: 'form_summary',
        },
        {
          text: 'Datum opgeslagen',
          sortable: false,
          align: 'start',
          value: 'registration_updated_at',
        },
        {
          value: 'actions',
          sortable: false,
          align: 'end',
        }
      ],
    }
  },
  // Watch the page variable, load new results when it changes
  watch: {
    page (newPage) {
      // Load new results
      this.loadSavedRegistrations(newPage)
    },
  },
  mounted () {
    // Load the first page
    this.loadSavedRegistrations(1)
  },
  methods: {
    rowClick(item) {
      this.openRegistrationModal(item)
    },
    // fillFormAgain(registration) {
    //  NOTE: this is not possible, because filling in again works only with actual sent registrations
    //   console.log(registration)
    //   // Open the form_fill route and prefill it with the registration values
    //   this.$router.push({ name: 'form_fill', params: {form_id: registration.form_id, force_reload: '0', registration_id: registration._id} })
    // },
    editRegistration(saved_registration) {
      // Edit the saved registration
      this.$router.push({ name: 'form_fill', params: {form_id: saved_registration.form_id, force_reload: '0', saved_registration_id: saved_registration._id} })
    },
    reloadSavedRegistrations() {
      this.loadSavedRegistrations(this.page)
    },
    async loadSavedRegistrations(page = 1) {
      let config = {
        params: {
          'page': page - 1, // API is zero-based
          // 'sort': '-registration_date', // Sort in descending order by appending a minus
        }
      }
      this.loading = true
      // Fetch results form the API
      await axios
          .get('api/saved-registrations', config)
          .then(response => {
            this.savedRegistrations = response.data.registrations
            this.pageCount = response.data.pages_count;
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            this.loading = false
          })
    },
    deleteSavedRegistration(item) {
      if (confirm('Weet u zeker dat u deze opgesalgen registratie wilt verwijderen? Dit kan niet ongedaan worden gemaakt.')) {
        // Delete the saved registration on the server
        axios
            .delete(`api/saved-registrations/${item._id}`)
            .then(() => {
              this.$toast.success('Opgeslagen registratie verwijderd.')
              // Reload the saved registrations
              this.reloadSavedRegistrations()
            })
            .catch(error => {
              console.log(error)
              this.$toast.error('Er is een fout opgetreden bij het verwijderen van de opgeslagen registratie.')
            })
      }
    },
    openRegistrationModal(item) {
      this.registration = item
      this.registrationModal = true
    },
    closeRegistrationModal() {
      this.registration = null
      this.registrationModal = false
    },
    // Make lodash functions available in the template
    _get(object, path) {
      return _.get(object, path)
    },
    _has(object, path) {
      return _.has(object, path)
    },
    _isEmpty(object) {
      return _.isEmpty(object)
    },
  },
}
</script>

<style scoped>

</style>